<mydeq-header
  [headerDetail]="{
    first_name: utils.userDetails.first_name,
    last_name: utils.userDetails.last_name
  }"
>
</mydeq-header>

<!-- START BODY SECTION-->
<section id="main-body">
  <div class="mydeq-global-content-main pt-3">
    <div
      class="container"
      [ngClass]="{
        'mydeq-global-confirmation-container': utils.isConfirmationPage
      }"
    >
      <div class="card card-inverse bg-primary mb-3" *ngIf="utils.placeName">
        <div class="card-body p-3" style="font-size: 18px">
          <div class="float-start text-white fw-bold mb-0 ps-1">
            {{ utils.placeName }}
          </div>
          <div class="float-end text-white fw-light mb-0 ps-1">
            {{ utils.placeAddress }}
          </div>
          <div class="clearfix"></div>
        </div>
      </div>

      <div class="clearfix">
        <div
          class="float-end"
          id="saveExitContainer"
          ngbDropdown
          placement="bottom-right"
          *ngIf="utils.showSaveAndExit"
          #saveExit="ngbDropdown"
        >
          <button
            id="saveExitBtn"
            class="btn btn-primary"
            type="button"
            ngbDropdownToggle
          >
            SAVE &amp; EXIT
          </button>
          <div ngbDropdownMenu>
            <div id="saveExitCollapse" class="card">
              <div class="card-body">
                <h5 class="fw-light">
                  To exit and save your progress up to the previous page
                  completed click YES or click NO to resume your submission.
                  Note: You can resume at any time by visiting your
                  myAPPLICATION or myCOMPLIANCE tabs.
                </h5>
              </div>
              <div class="clearfix"></div>
              <div class="d-grid gap-2 d-md-block">
                <button
                  type="button"
                  class="btn btn-danger float-start w-auto text-white"
                  (click)="saveExit.close()"
                >
                  <span class="arrow left float-start">
                    <i class="fas fa-chevron-left"></i>
                  </span>
                  <span class="float-end">NO</span>
                </button>
                <button
                  type="button"
                  class="btn btn-primary float-end w-auto"
                  (click)="saveAndExit()"
                >
                  <span class="float-start">YES</span>
                  <span class="arrow right ps-3">
                    <i class="fas fa-chevron-right"></i>
                  </span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- <div
          class="float-end"
          id="saveExitContainer"
          placement="bottom-right"
          *ngIf="showExit"
        >
          <button
            id="ExitBtn"
            class="btn btn-primary text-center"
            type="button"
            style="width: 100px"
            (click)="exitNavigation()"
          >
            EXIT
          </button>
        </div> -->
        <div class="float-end pe-0">
          <button
            id="needHelpBtn"
            class="btn mx-0"
            type="button"
            (click)="showNeedHelp()"
          >
            NEED HELP ?
          </button>
        </div>
        <div class="clearfix"></div>
      </div>

      <div class="clearfix"></div>
      <section class=" jumbotron {{ pageClass }}">
        <div class="card card-default page-body">
          <div class="card-header border-bottom">
            <h1 class="card-title text-primary divider-horizontal fw-bold">
              {{ utils?.title | uppercase }}
            </h1>
          </div>
          <div class="mx-2">
            <!-- <comments
              *ngIf="displayReviewComments"
              [isPageLevel]="true"
              [defaultClass]="'comments'"
              [reviewList]="utils.reviewComments"
            ></comments> -->
          </div>

          <div class="mt-3">
            <router-outlet
              (activate)="onActivate($event)"
              (deactivate)="onDeactivate($event)"
            ></router-outlet>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
<div class="clearfix"></div>

<mydeq-footer></mydeq-footer>

<div
  *ngIf="utils.showLoadingSign"
  class="modal-backdrop fade show"
  style="z-index: 1052"
>
  <div class="text-center">
    <div class="mydeq-busy">
      <div class="mydeq-busy-spinner"></div>
    </div>
  </div>
</div>
<div
  *ngIf="utils.showLoadingSign"
  class="modal fade show"
  id="mydeq-busy"
  style="z-index: 1055"
>
  <div class="text-center">
    <div class="mydeq-busy">
      <div class="mydeq-busy-spinner"></div>
    </div>
  </div>
</div>

<app-need-help></app-need-help>
